import BuyButton from "./BuyButton";

export default BuyButton;
